import { OutlinedInput, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAccessibility } from '../../../../../Store/contexts/AccessibilityContext';
import { sxInput, sxMessageTextField, sxSubTitle } from '../../../../../assets/styles/CommonSxProps';
import DefaultButton from '../../../../../components/Accessibility/DefaultButton';
import PageTitle from '../../../../../components/Accessibility/PageTitle';
import VoltarButton from '../../../../../components/Accessibility/VoltarButton';
import LoadingApp from '../../../../../components/LoadingApp';
import { getTempoRespostaChat, novaConversa } from '../../../../../services/SaudeBemEstar/GestaoDeCronicosService';
import { sxDarkGreyBody } from '../../../../MeuPlano/PermissoesVisualizacao/sxProps';

const NovaConversa: React.FC = () => {

  const accessibility = useAccessibility();
  const navigate = useNavigate();
  const [assunto, setAssunto] = useState<string>('');
  const [mensagem, setMensagem] = useState<string>('');
  const [tempoRespostaChat, setTempoRespostaChat] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    fetchTempoRespostaChat();
  }, []);

  const fetchTempoRespostaChat = async () => {
    const response = await getTempoRespostaChat();
    if (response?.status === 200) {
      const tempoResposta = response.data;
      setTempoRespostaChat(tempoResposta);
    } else {
      console.error(response);
    }
  }

  const handleNewConversation = async () => {
    setLoading(true);
    const response = await novaConversa(assunto, mensagem);
    if (response?.status === 200) {
      navigate(`/saudeBemEstar/gestaoDeCronicos/conversaEquipe/conversas/${response.data}/chat`);
    } else {
      console.error(response);
    }
    setLoading(false);
  }

  return (
    <>
      <LoadingApp showLoading={loading} text={'Criando mensagem...'} />
      <div className='chat-infos-container'>
        <PageTitle text='Chat com equipe' />

        <Typography
          sx={sxDarkGreyBody} style={accessibility.textStyleAccessibility} tabIndex={0}
        >
          Este é um canal de contato exclusivo com o Programa do Gestão de Crônicos. 
          <br />
          <br />
          Responderemos em até {tempoRespostaChat} horas úteis.
        </Typography>

        <div className='textfield-input-area'>
          <Typography sx={sxSubTitle}>Assunto</Typography>
          <OutlinedInput
            fullWidth
            type={'text'}
            value={assunto}
            onChange={(e) => { setAssunto(e.target.value); }}
            name='cost'
            maxRows={1}
            inputProps={{ maxLength: 30 }}
            sx={sxInput}
            placeholder="Digite o assunto a resolver"
            style={accessibility.textStyleAccessibility}
          />
        </div>
        <div className='textfield-input-area'>
          <Typography sx={sxSubTitle}>Detalhes</Typography>
          <TextField
            id="outlined-textarea"
            type='text'
            value={mensagem}
            onChange={(e) => { setMensagem(e.target.value); }}
            placeholder='Conte um pouco mais sobre o motivo de seu contato'
            multiline
            inputProps={{ maxLength: 500 }}
            sx={sxMessageTextField}
          />
        </div>
        <DefaultButton text='Iniciar nova conversa' onClick={handleNewConversation} disabled={assunto.trim() === '' || mensagem.trim() === ''} />
        <VoltarButton text='Voltar' onClick={() => window.history.back()} />
      </div>
    </>
  )
}

export default NovaConversa;